import { render, staticRenderFns } from "./Detail5.vue?vue&type=template&id=1f5acc58&scoped=true&"
import script from "./Detail5.vue?vue&type=script&lang=js&"
export * from "./Detail5.vue?vue&type=script&lang=js&"
import style0 from "./Detail5.vue?vue&type=style&index=0&id=1f5acc58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5acc58",
  null
  
)

export default component.exports